import z from "zod";

export const CustomPeriodSchema = z.object({
  type: z.enum(['MONTHS', 'CUSTOM', '1M', '3M', '6M', '12M', '36M', '48M']),
  value: z.string().optional().nullable(),
  startDate: z.any().optional().nullable(),
  endDate: z.any().optional().nullable(),
})